// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__QGSPV","selected":"Pagination_selected__k8tm9","dots":"Pagination_dots__LkgMR"};